export default __webpack_public_path__ + "static/media/Caffe2.f1ee0768.webp";